<card-wrapper>
  <div class="align-wrapper">
    <h2 class="title" translate="dashboard.label.no-accounts"></h2>
    <button
      class="button button-border"
      routerLink="accounts/real"
      translate="open-account.label.open-account"
    ></button>
  </div>
</card-wrapper>
